export default {
    contactFirstName: "contact.first_name",
    contactLastName: "contact.last_name",
    contactName: "contact.name",
    contactFullName: "contact.full_name",
    contactCreated: "contact.created_at",
    contactLastActivity: "contact.last_activity",
    contactIsActive: "contact.is_active",
    contactEmail: "contact.email",
    contactPhone: "contact.phone",
    telegramId: "contact.telegram_id",
    regForm: "contact.reg_from",
    contactPassword: "contact.password",
    contactCountry: "contact.country",
    contactTimezone: "contact.timezone",
    contactCurrency: "contact.currency",
    contactCity: "contact.city",
    contactTag: "contact.tag",
    contactText: "contact.text",
    contactTextarea: "contact.textarea",
    contactDropdown: "contact.dropdown",
    contactAdditionalField: "contact.custom_field_",
    productsCount: "contact.products_count",
    contactProducts: "contact.products",
    contactOffers: "contact.offers",
    contactCertificates: "contact.certificates",
    contactAccessGroups: "contact.access_groups",
    contactSource: "contact.source",
    contactReferer: "contact.referrer",
    contactInitialPage: "contact.initial_page",
    contactUtmSource: "contact.utm_source",
    contactUtmCampaign: "contact.utm_campaign",
    contactUtmMedium: "contact.utm_medium",
    contactUtmTerm: "contact.utm_term",
    contactUtmContent: "contact.utm_content"
}
